import UZod from "@repo/utils/UZod";
import Organization from "./Organization.js";
import Staff from "./Staff.js";
import UObject from "@repo/utils/UObject";
import Base64 from "@repo/utils/Base64";
import { z } from "zod";
import Recurrence from "./Recurrence.js";

type Bookable = {
  id: Bookable.Id;
  organizationId: Organization.Id;
  templateId: Bookable.Template.Id;
  recurrenceId?: Recurrence.Id;

  startAt: Date;
  endAt: Date;
  capacity?: number;
  availability?: number;
  staffId?: Staff.Id;
};

namespace Bookable {
  export type Id = `bo_${string}`;
  export namespace Id {
    export const is = (id: string | undefined): id is Id =>
      !!id?.startsWith("bo_");
    export const zodSchema: z.ZodType<Id, z.ZodTypeDef, string> =
      UZod.predicate(is, "Invalid bookable id.") as any;
  }

  export type Resolved = UObject.Override<Template, Bookable> & {
    template: Template;
  };

  export type Params = Omit<Bookable, "id" | "organizationId" | "availability">;

  export type AdminSupplement = {
    id: Bookable.Id;
    numSignups: number;
    checkedInCount: number;
  };

  export type Template = {
    id: Template.Id;
    name: string;
    description?: string;
    imgUrl: string;
    priceCents: number;
    hidden: boolean;
  };

  export namespace Template {
    export type Id = `bt_${string}`;

    export namespace Id {
      export const is = (id: string | undefined): id is Id =>
        !!id?.startsWith("bt_");
      export const zodSchema = (message = "Invalid bookable template id.") =>
        UZod.predicate(is, message);
    }

    export type AdminSupplement = {
      id: Template.Id;
      bookableCount: number;
    };

    export type Params = UObject.PartialBy<
      Omit<Template, "id" | "imgUrl"> & {
        imgBase64?: Base64;
        imgMimeType?: string;
      },
      "hidden"
    >;
  }
}

export default Bookable;
